import ComingSoon from "components/ComingSoon";
import React from "react";

const FacebookAds = () => {
  return <ComingSoon />;
};

export default FacebookAds;
